import {
  BaseFormViewModel,
} from '../types';
import {
  SurveyDTO,
} from './surveyDTO';

export class SurveyFormViewModel extends BaseFormViewModel<SurveyDTO> {
  id: string;

  title: string;

  description: string;

  questions: any;

  isActive: boolean;

  availableCountries: Array<string>;

  constructor(dto: SurveyDTO) {
    super();
    const {
      id,
      title,
      description,
      questions,
      isActive,
      availableCountries,
    } = dto;
    Object.assign(this, {
      id,
      title,
      description,
      questions,
      isActive,
      availableCountries,
    });
  }

  toDTO() {
    return this.questions.map((question: any) => question.type = question.type[0]);
  }
}
